import { render, staticRenderFns } from "./ModalRoles.vue?vue&type=template&id=65e7b462"
import script from "./ModalRoles.vue?vue&type=script&lang=js"
export * from "./ModalRoles.vue?vue&type=script&lang=js"
import style0 from "./ModalRoles.vue?vue&type=style&index=0&id=65e7b462&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports